import {
    Button,
    Container,
    DialogActions,
    Grid,
    Paper,
} from "@material-ui/core";
import FormBuilder from "../../../components/form-builder";
import * as Yup from "yup";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import appService from "../../../services/app.service";
import { useErrorHandler } from "../../../hooks";
import { useSnackbar } from "notistack";
import AdsTable from "./adsTables";

const formWrapper = (props) => <Grid container spacing={2} {...props} />;

const form = [
    {
        _type: "textField",
        _wrapper: (props) => <Grid item xs={12} sm={12} {...props} />,
        name: "showAdsBetweenRows",
        label: "نمایش تبلیغ بین ردیف",
        type: "number",
    },
];
const schema = Yup.object().shape({});

export function AdsPage() {
    const { initials } = useSelector((s) => s.app);
    const errorHandler = useErrorHandler();
    const { enqueueSnackbar } = useSnackbar();

    const initialValues = useMemo(() => {
        const {
            showAdsBetweenRows = 3,
        } = initials || {};

        return {
            showAdsBetweenRows,
        };
    }, [initials]);

    async function handleSubmit(values, helpers) {
        const { error } = await appService.updateMetadata(values);
        if (error) {
            return errorHandler();
        }
        enqueueSnackbar("عملیات با موفقیت انجام شد.", { variant: "success" });
        helpers.resetForm({ values });
        appService.getInitials();
    }

    return (
        <Container>
            <Paper className="my-2 p-2">
                <FormBuilder
                    schema={schema}
                    initialValues={initialValues}
                    handleSubmit={handleSubmit}
                    form={form}
                    actionComponent={({ isSubmitting, resetForm, dirty }) => (
                        <DialogActions>
                            {dirty && (
                                <Button
                                    onClick={resetForm}
                                    color="primary"
                                    disabled={isSubmitting}
                                >
                                    لغو
                                </Button>
                            )}
                            <Button
                                type="submit"
                                disabled={isSubmitting || !dirty}
                                variant="contained"
                                color="primary"
                            >
                                ذخیره
                            </Button>
                        </DialogActions>
                    )}
                    formWrapper={formWrapper}
                />
            </Paper>

            <div className="mt-3">
                <AdsTable 
                    categories={initials?.enums?.advertisementCategory}
                />
            </div>
        </Container>
    );
}
